import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ToolbarSimple from '../../../Utils/Toolbar/ToolbarSimple';
import Tabs, { TabPane } from 'rc-tabs';
import TabContent from 'rc-tabs/lib/TabContent';
import ScrollableInkTabBar from 'rc-tabs/lib/ScrollableInkTabBar';

import ProductosGrid from './productoGrid';
import FacturasGrid from './facturasGrid'
// import TransporteDetalle from './transporteDetalle';
// import GastoGrid from './Gastos/gastosGrid';
import PagosContainer from './Pagos/pagocContainer';
import DespachoContainer from './Despacho/despachoContainer';
// import ReintegroGrid from './Reintegros/reintegro';
// import OCpreview from './previewOC/OCpreview';

import {RenderMoneda, RenderDateTime} from "../../../Utils/renderField/renderTableField";
import { getSimbolo} from "../../../Utils/renderField/renderTableField";
import { Link, Redirect } from 'react-router-dom';
import {TIPO_ENTREGA} from "../../../../../utility/constants";
import LoadMask from "../../../Utils/LoadMask/LoadMask";

import Swal from 'sweetalert2';
import DetalleDespachoFormBodega from './despachoForm';


export default class DetalleOC extends Component {
    static propTypes = {
        item: PropTypes.object.isRequired,
        loader: PropTypes.bool.isRequired,
        onPageChange: PropTypes.func,
        onSortChange: PropTypes.func,
    };

    static defaultProps = {
        loading: false
    };

    componentDidMount() {
        this.props.clear()
        let id = this.props.match.params.id
        let bodega = this.props.match.params.bodega
        this.props.leerDespacho(id, bodega);
    }
    getEntrega =(valor)=>{
        let entrega =''
        TIPO_ENTREGA.forEach((item,index)=>{
            if (item.value === valor){
                entrega = item.label
            }
        })
        return entrega
    }
    rechazarDespacho = () => {
        Swal.fire({
            title: '¿Desea rechazar la orden de despacho?',
            text: '¡No podrá revertir esta acción!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: '¡Sí, anular!',
            cancelButtonText: 'No, cancelar',
            reverseButtons: true
        }).then((result) => {
            if (result.value) {
                this.props.rechazarDespacho({id:this.props.match.params.id, id_bodega_origen: this.props.match.params.bodega });
            }
        });
    }
    handleSubmit = (data) =>{
        this.props.setLoader(true)
        this.props.aceptarRechazo({
            id: this.props.match.params.id,
            id_bodega_origen: this.props.match.params.bodega,
            data
        })
    }
    guardarDespacho = () =>{
        this.props.guardarDespacho({
            id: this.props.match.params.id,
            id_bodega_origen: this.props.match.params.bodega
        })
    }
    render() {
        const { item, data, loader, listar: onPageChange, onSortChange, eliminar,cuentas, permisos } = this.props;
        let CPid = this.props.match.params.id
        const OV = 3;
        const VI = 7;
        const DESPACHO_VENTA_INTERNA = 80;

        if (item.tipo_movimiento == DESPACHO_VENTA_INTERNA)
            if (!permisos.despacho_venta_interna) return <Redirect to={`/`} />

        return (
            <div className="Container bg-white">
                <LoadMask loading={loader} light>
                    {
                        item && (
                            <div className="m-t p-t fnt-size">
                                {console.log("detalle despachos", item)}
                            <div className="row m-none" style={{paddingTop:"15px"}}>
                                <div className="col-lg-6 col-md-6 col-12 d-flex align-items-center">
                                    <h3 className="t-primary m-none">{ item ? item.no_despacho:""}</h3>
                                </div>
                            </div>

                            <br/>
                            {/* DATOS GENERALES */}
                            <hr style={{borderTop: "2px solid rgb(223, 224, 224)", margin:"10px 15px"}}/>
                            <div className="row m-none">
                                <div className="col-lg-4 col-md-6 col-12">
                                    <span className="m-none t-mostaza semibold">Emitida por: </span><br/>
                                    {
                                        item.despachado_por && (
                                            <span className="m-none t-musgo semibold">{`${item.despachado_por.first_name} ${item.despachado_por.last_name}`}</span>
                                        )
                                    }
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <span className="m-none t-mostaza semibold">Bodega origen: </span><br/>
                                    {
                                        item.bodega_origen && (
                                            <span className="m-none t-musgo semibold">{`${item.bodega_origen.nombre}`}</span>
                                        )
                                    }
                                </div>
                                <div className="col-lg-4 col-md-6 col-12">
                                    <span className="m-none t-mostaza semibold">Bodega destino: </span><br/>
                                    {
                                        item.bodega_destino && (
                                            <span className="m-none t-musgo semibold">{`${item.bodega_destino.nombre}`}</span>
                                        )
                                    }
                                </div>
                                {
                                    (item.cliente_orden) && (
                                        <div className="col-lg-4 col-md-6 col-12">
                                            <span className="m-none t-mostaza semibold">Cliente: </span><br/>
                                            <span className="m-none t-musgo semibold">{`${item.cliente_orden.nombre}`}</span>
                                        </div>
                                    )
                                }
                            </div>
                            <br/>{/* DESCRIPCION */}

                            <div className="col-12">
                                <span className="m-none t-primary bold" >Descripción</span>
                            </div>
                            <hr style={{borderTop: "2px solid rgb(223, 224, 224)", margin:"0px 15px 10px 15px"}}/>
                            <div className="row m-none">
                                <div className="col-12">
                                    <span className="m-none t-musgo semibold">{`${item.descripcion ? item.descripcion : "Sin Descripcion" }`}</span>
                                </div>
                            </div>

                            <br/> {/*CONDICIONES DE ENTREGA */}
                            <div className="col-12">
                                <span className="m-none t-primary bold" >Fecha: </span>
                            </div>
                            <hr style={{borderTop: "2px solid rgb(223, 224, 224)", margin:"0px 15px 10px 15px"}}/>
                            <div className="row m-none">
                                <div className="col-md-4 col-sm-6 col-12">
                                    <span className="m-none t-musgo semibold"><RenderDateTime fecha={item.fecha} ></RenderDateTime></span>
                                </div>

                            </div>
                            <br/> {/*CONDICIONES COMERCIALES */}

                            {
                                item.documento &&(
                                    <div className="row m-none">
                                        <div className="col-12">
                                            <a target="_blank" href={item.documento} className="btn btn-azul-claro align-self-center">VER DOCUMENTO</a>
                                        </div>
                                    </div>
                                )
                            }
                            <br/> {/*  */}
                            <div className="row">
                                <div className="mb-4 col-12">
                                    <div className="mb-4 ">
                                        <div className=""><h6 className="m-0"></h6></div>
                                        <div className="p-0 px-3 pt-3 p-b">
                                        <Tabs
                                            defaultActiveKey="DETALLEOV"
                                            tabBarPoition = "top"
                                            onchange={this.callback}
                                            renderTabBar ={()=><ScrollableInkTabBar/>}
                                            renderTabContent={()=><TabContent/>}

                                        >
                                            <TabPane tab="PRODUCTOS" key="PRODUCTOS">
                                         
                                                {item.orden && [OV, VI].includes(item.orden.tipo_orden) // Solo para las orden de venta / odenen venta inventario
                                                ?
                                                <DetalleDespachoFormBodega
                                                    {...this.props}
                                                    item = {item}
                                                    onSubmit={this.handleSubmit}
                                                    rechazarDespacho={this.rechazarDespacho}
                                                    guardarDespacho={this.guardarDespacho}
                                                    loader={loader}                                                />
                                                :
                                                <ProductosGrid
                                                    detalle_orden={item.detalle_despacho}
                                                    moneda={'Q.'}
                                                    onSubmit={this.handleSubmit}
                                                    rechazarDespacho={this.rechazarDespacho}
                                                    loader={loader}
                                                />}
                                            </TabPane>

                                        </Tabs>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>

                        )
                    }

                </LoadMask>
            </div>

        )
    }
}
